module.exports = __webpack_public_path__ + "img/logo_Ueasy.4d7056f1.png";